import { motion } from "framer-motion";
import { Coffee, Droplets, Shield } from "lucide-react";

const PROTOCOLS = [
  {
    icon: Coffee,
    title: "The Caffeine Buffer",
    body: "A precisely timed morning protocol that overrules the cortisol awakening response, zeroing the cortisol spike before it can lock your nervous system into survival mode.",
  },
  {
    icon: Droplets,
    title: "The Saline Hydration Anchor",
    body: "A targeted hydroelectrolytic reset that restores cell membrane potential to -70mV, re-establishing the electrical baseline your mitochondria require to produce clean energy.",
  },
  {
    icon: Shield,
    title: "The Somatic Shield",
    body: "A somatic deployment that seals the epithelial tight junctions and blocks biological cortisol contagion during high-stakes board negotiations — clarity holds while others react.",
  },
];

const ResolutionSection = () => (
  <section className="py-24 lg:py-36 border-t border-white/10" data-testid="resolution-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-3xl"
      >
        <p className="font-mono-tech text-xs uppercase tracking-[0.35em] text-[#00FF8F] mb-6" data-testid="resolution-overline">
          03 / The Somatic Shield Resolution
        </p>
        <h2 className="font-serif-display text-2xl sm:text-3xl lg:text-4xl tracking-tight leading-tight text-white font-medium" data-testid="resolution-heading">
          The Joe Fenix Method
          <span className="italic text-[#00FF8F]"> intervenes upstream.</span>
        </h2>
        <p className="mt-8 text-base leading-relaxed text-[#A6A6AD] font-light">
          Not another layer of commercial biohacking. Three precise interventions that
          overrule the failure at its biological source.
        </p>
      </motion.div>

      <div className="mt-16 grid md:grid-cols-3 gap-px bg-white/10 border border-white/10">
        {PROTOCOLS.map((p, i) => (
          <motion.article
            key={p.title}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.9, delay: i * 0.12, ease: [0.22, 1, 0.36, 1] }}
            className="group bg-[#0A0A0A] p-10 hover:bg-[#111113] transition-colors duration-500"
            data-testid={`protocol-card-${i + 1}`}
          >
            <p.icon size={22} strokeWidth={1.5} className="text-[#00FF8F] mb-8" />
            <h3 className="font-serif-display text-xl sm:text-2xl text-white font-medium leading-snug" data-testid={`protocol-title-${i + 1}`}>
              {p.title}
            </h3>
            <p className="mt-5 text-sm leading-relaxed text-[#A6A6AD] font-light" data-testid={`protocol-body-${i + 1}`}>
              {p.body}
            </p>
          </motion.article>
        ))}
      </div>
    </div>
  </section>
);

export default ResolutionSection;
